const API_URL = process.env.REACT_APP_DIGISPEAK_API_BASE_URL;
const API_KEY = process.env.REACT_APP_DIGISPEAK_API_KEY;
const API_ROOT = process.env.REACT_APP_DIGISPEAK_API_ROOT_URL;
const URL_LANDING = process.env.REACT_APP_DIGISPEAK_LANDING_URL;
const FREEMIUM_URL = process.env.REACT_APP_DIGISPEAK_FREEMIUM_URL;
const LOGOUT_GUARD_KEY = "skipFreemiumRedirectAfterLogout";

const isTrialAccessState = (userData) =>
    String(
        userData?.subscriptionAccessState || userData?.SubscriptionAccessState || ""
    ).toLowerCase() === "trial";

const isFreemiumLegacySession = (userData) => {
    if (!userData) {
        return false;
    }

    const normalizedPlanName = String(
        userData.studentPlanName || userData.planName || ""
    ).toLowerCase();

    return (
        userData.isFreemiumPlan === true ||
        userData.hasActiveFreemiumPaidTrial === true ||
        isTrialAccessState(userData) ||
        normalizedPlanName === "freemium"
    );
};

const isLogoutBootstrap =
    window.location.pathname === "/logout" ||
    new URLSearchParams(window.location.search).has("logout") ||
    window.sessionStorage.getItem(LOGOUT_GUARD_KEY) === "1";

if (isLogoutBootstrap) {
    window.localStorage.removeItem("loggedAppUser");
    window.localStorage.removeItem("digispeakFreemiumSession");
    window.sessionStorage.setItem(LOGOUT_GUARD_KEY, "1");
}

let userInfo = JSON.parse(window.localStorage.getItem("loggedAppUser")) || null;
if (userInfo && !userInfo.token) { // workaround for old user data
    window.localStorage.removeItem("loggedAppUser");
    userInfo = null;
}
if (isFreemiumLegacySession(userInfo)) {
    window.localStorage.removeItem("loggedAppUser");
    userInfo = null;
}
const USER_DATA = userInfo;
const USER_ID = USER_DATA ? USER_DATA.id : null;
const USER_TOKEN = USER_DATA ? USER_DATA.token : null;

export { API_URL, API_KEY, API_ROOT, URL_LANDING, FREEMIUM_URL, USER_DATA, USER_ID, USER_TOKEN };
